import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/CategoryHeader'
import LanguageTable from '../components/leads/InstitutionCreate'
import Footer from '../components/shared/Footer'

const CategoryCreate = () => {
    return (
        <>
            <PageHeader>
               
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LanguageTable />
                </div>
            </div>
            
        </>
    )
}

export default CategoryCreate